<style>
  .pm-table {
    display: table;
    border-collapse: separate;
    border-spacing: 15px 0px 15px 0px;
  }
  .pm-row {
    display: table-row;
  }
  .pm-cell {
    display: table-cell;
    padding: 10px 20px 10px 0px;
    border-bottom: 1px solid #dddddd;
  }
</style>

<div>
  <!--<app-help-icon [helpContextName]="'payment-methods-general'"></app-help-icon>-->

  <div class="pm-table" class="containerMargins">
    @for (item of this.paymentMethods; track item) {
      <div class="pm-row">
        <div class="pm-cell">{{ item.nickname }}</div>
        <div class="pm-cell">{{ item.cardType }}</div>
        <div class="pm-cell">{{ item.cardFirst6 }}****{{ item.cardLast4 }}</div>
        <div class="pm-cell">
          {{ item.cardExpMonth }}/{{ item.cardExpYear }}
        </div>
        <!--<div class="pm-cell" ><input type="button" (click)="payWith(item, '0ms', '0ms')" value="Charge" /></div>-->
      </div>
    }
  </div>

  <input
    class="button_secondary button_var_2"
    type="button"
    (click)="createNew()"
    value="Add a new card"
  />
</div>
